import { forwardRef } from 'react';
import { getOrgNumberFormat } from '@bits/i18n';

import {
  ThemedCountrySpecificStringInput,
  ThemedCountrySpecificStringInputProps,
} from './themed-country-specific-string-input';

export const ThemedOrganizationNumberInput = forwardRef<
  HTMLInputElement,
  Omit<ThemedCountrySpecificStringInputProps, 'getStringFormat'>
>(({ defaultCountryCode = 'SE', language = 'en', ...props }, ref) => {
  return (
    <ThemedCountrySpecificStringInput
      {...props}
      language={language}
      defaultCountryCode={defaultCountryCode}
      getStringFormat={getOrgNumberFormat}
    />
  );
});
